import { render, staticRenderFns } from "./TransboundaryRecord.vue?vue&type=template&id=468b1196&scoped=true&"
import script from "./TransboundaryRecord.vue?vue&type=script&lang=js&"
export * from "./TransboundaryRecord.vue?vue&type=script&lang=js&"
import style0 from "./TransboundaryRecord.vue?vue&type=style&index=0&id=468b1196&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468b1196",
  null
  
)

export default component.exports